export enum CellActionType {
    CELL_NEW,
    CELL_CHANGE,
    CELL_DELETE,
    WIDGET_ADD,
    WIDGET_DELETE
}
